import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SubCategoryInterface, TableListItem } from '../assets/interfaces/FX_POS_Interfaces';

interface DineInTableProps {
  selectedTable: TableListItem | null;
  setSelectedTable: (tbl: TableListItem | null) => void;
}

const DineInTableContext = createContext<DineInTableProps | undefined>(undefined);

export const useDineInTable = () => {
  const context = useContext(DineInTableContext);
  if (context === undefined) {
    throw new Error('DineInTableContext must be used within a DineInTableProvider');
  }
  return context;
};

interface DineinTableProviderProps {
  children: ReactNode;
}

export const DineInTableProvider: React.FC<DineinTableProviderProps> = ({ children }) => {
  const [selectedTable, setSelectedTable] = useState<TableListItem | null>(null);

  return (
    <DineInTableContext.Provider value={{ selectedTable, setSelectedTable }}>
      {children}
    </DineInTableContext.Provider>
  );
};
